module.exports = __webpack_public_path__ + "static/media/sound4.a49fcccf.mp3";